import { render, staticRenderFns } from "./TreeselectDemo.vue?vue&type=template&id=259658e4&"
import script from "./TreeselectDemo.vue?vue&type=script&lang=js&"
export * from "./TreeselectDemo.vue?vue&type=script&lang=js&"
import style0 from "./TreeselectDemo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports